import { FormControl, Select, MenuItem, FormHelperText } from '@mui/material';
import { forwardRef } from 'react';
import theme from '../../theme';

const CustomSelectBox = forwardRef(({ options, value, error, helperText, ...props }, ref) => {
  return (
    <FormControl fullWidth>
      <Select
        displayEmpty
        value={value}
        inputRef={ref}
        error={error}
        {...props}
        sx={{
          height: '46px',
          '& .MuiSelect-select': {
            fontSize: '14px',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.grey.line,
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.grey.line,
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.black[9],
          },
        }}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {error && helperText && (
        <FormHelperText error sx={{ margin: 0 }}>
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
});

export default CustomSelectBox;
